/*
  Таблица находок реестра банкротств - вариант Б, 27.10.2026.

  Четыре колонки, как в согласованном макете: должник и что с подачей, что нашёл реестр,
  счета, переход. Решение здесь НЕ принимается: дата принятия заявления вносится на карточке
  счёта, где рядом долг и состав должников, - сюда человека только приводят. Порядок, отбор и
  страницы задаёт сервер: сначала находки, что держат подачу.
*/

import { Link } from 'react-router-dom'

import { Tag } from './Common.jsx'
import PageBar from './PageBar.jsx'

export default function RegistryFindingsTable({ rows, bar }) {
  return (
    <>
      <table className="table table--fixed">
        <thead>
          <tr>
            <th>Должник</th>
            <th>Что нашёл реестр</th>
            <th>Счёт</th>
            <th>Перейти</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((item) => (
            <tr key={item.id}>
              <td>
                <b>{item.person_name}</b>
                <div>
                  {item.holds ? (
                    <Tag kind="burn">подача остановлена</Tag>
                  ) : (
                    <Tag kind="warn">спорное совпадение</Tag>
                  )}
                </div>
              </td>
              <td data-label="Что нашёл реестр">
                {item.summary}
                <div className="muted">Совпали: {item.basis}</div>
              </td>
              <td data-label="Счёт">
                {item.accounts.map((account) => (
                  <div key={account.id}>№ {account.number}</div>
                ))}
              </td>
              <td data-label="Перейти">
                {item.accounts.map((account) => (
                  <div key={account.id}>
                    <Link to={`/accounts/${account.id}`}>Открыть счёт →</Link>
                  </div>
                ))}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <PageBar {...bar} what="находок" />
    </>
  )
}
